var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4999 43.075L39.875 33.4501L49.4999 23.8251C51.4249 21.9001 51.4249 18.8751 49.4999 16.9501C47.5749 15.0251 44.55 15.0251 42.625 16.9501L33 26.5751L23.375 16.9501C21.45 15.0251 18.4251 15.0251 16.5001 16.9501C14.5751 18.8751 14.5751 21.9001 16.5001 23.8251L26.125 33.4501L16.5001 43.075C14.5751 45 14.5751 48.025 16.5001 49.95C18.4251 51.875 21.45 51.875 23.375 49.95L33 40.325L42.625 49.95C44.55 51.875 47.5749 51.875 49.4999 49.95C51.4249 48.025 51.4249 45 49.4999 43.075Z",
    fill: "#FF5F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelOrder);
export default __webpack_public_path__ + "static/media/cancel_order.c842ebf0286b45cfdf48b869abeb5871.svg";
export { ForwardRef as ReactComponent };